export default {
  validate: value => new RegExp('^[a-zA-Z0-9._]{4,}$').test(value),
  message: 'Ne peut contenir que des caractères alphabétiques, chiffres et _'
}
